import React, { CSSProperties, FC, PropsWithChildren } from "react";
import styled from "styled-components";
import Text from "common/Typography/Text";
import { hexToRGB } from "@shared/utils/misc";
import CloseOutlined from "@ant-design/icons/CloseOutlined";

interface BannerProps {
  onCloseClick?: () => void;
  className?: string;
  style?: CSSProperties;
  color?: string;
  innerWrapperStyle?: CSSProperties;
}

const Banner: FC<PropsWithChildren<BannerProps>> = ({
  children,
  onCloseClick,
  className,
  color,
  style,
  innerWrapperStyle,
}) => {
  return (
    <BannerWrapper $color={color} as="div" className={className} style={style}>
      <div style={{ flex: "auto", ...innerWrapperStyle }}>{children}</div>
      {onCloseClick && (
        <StyledCloseIcon onClick={onCloseClick} style={{ color }} />
      )}
    </BannerWrapper>
  );
};

export default Banner;

export const BannerWrapper = styled(Text)<{ $color?: string }>`
  width: 100%;
  flex: none;
  display: flex;
  justify-content: space-between;
  padding: 12px 32px;
  background-color: ${(p) =>
    hexToRGB(p.$color ?? p.theme.colors.primaryBlue, 0.2)};
  color: ${(p) => p.$color ?? p.theme.colors.primaryText};
  text-align: center;
  position: relative;
`;
const StyledCloseIcon = styled(CloseOutlined)<any>`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding: 6px;

  @media (max-width: 600px) {
    right: 4px;
  }
`;
